import { render, staticRenderFns } from "./DeclarationsList.vue?vue&type=template&id=43b929f2&scoped=true&"
import script from "./DeclarationsList.vue?vue&type=script&lang=ts&"
export * from "./DeclarationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b929f2",
  null
  
)

export default component.exports